import * as vp from 'vopay';

import { FunctionComponent } from 'react';
import styles from './ReportDetailsPage.module.scss';
import { useTranslation } from 'react-i18next';

import usePostDownloadReport from '@/hooks/useApi/usePostDownloadReport';
import useFileDownload from '@/hooks/useFiledDownload';
import { Button } from 'UI';

const { Box, withStyles, Table } = vp;
const classes = withStyles(styles);

type FC = FunctionComponent<ReportDetailHistoryTableProps>;

type ReportDetailHistoryTableProps = {
  reports: vp.AccountTransactionReports[];
};

type Column = {
  generatedOn: string;
  fromDate: string;
  toDate: string;
  reportID: string;
};

const ReportDetailHistoryTable: FC = ({ reports }: ReportDetailHistoryTableProps) => {
  const { downloadXlsxFileType } = useFileDownload();
  const [, , downloadReport] = usePostDownloadReport({});
  const { t } = useTranslation('translations', { keyPrefix: 'Reports.ReportTable.Columns' });

  const columns: vp.ColConfig<Column, string>[] = [
    {
      id: 'GeneratedOn',
      header: t('generatedOn'),
      align: 'left',
      field: 'generatedOn',
      style: {
        whiteSpace: 'nowrap',
      },
    },
    {
      id: 'DateRange',
      header: t('dateRange'),
      align: 'left',
      style: {
        whiteSpace: 'nowrap',
      },
      template: (row) => (
        <Box ai="center" jc="sb" width="100%">
          <div>
            {row.data?.fromDate} to {row.data?.toDate}
          </div>
          <Button
            id={`download-button-${row.data.fromDate}-${row.data.toDate}`}
            size="small"
            onClick={async () => {
              const { Success, ReportFile, ReportName } = await downloadReport({
                ReportID: row.data.reportID || '',
              });
              if (Success) {
                downloadXlsxFileType(ReportFile, ReportName);
              }
            }}
          >
            Download
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <>
      <Box className={classes('oneTimeReportsTableContainer', 'scrollbar')}>
        <Table
          zebra
          id="oneTimeReportsTable"
          style={{
            '--headerBackground': '#2d2d2d',
            '--headerColor': '#fbfbfb',
            '--headerBorderRadius': '14px',
            '--thBorderBottom': 'none',
          }}
          version="2"
          rows={reports.map((value, index) => {
            return {
              id: index,
              data: {
                generatedOn: value.ScheduledDate,
                fromDate: value.FromDate,
                toDate: value.ToDate,
                reportID: value.ID,
              },
            };
          })}
          columns={columns}
        />
      </Box>
    </>
  );
};

export default ReportDetailHistoryTable;
